export enum AssetUrl {
  S3_URI = 'https://contilio-360.s3.eu-west-2.amazonaws.com/prototype',
}